import React from 'react';
import { BentoCard } from './BentoCard';
import { OverlayRows, rowKeyFor } from './OverlayRows';

// <purpose>The vocabulary SECTION of the "Texte & Vokabular" tab: per-value editing of the
// classification wordings and letters this tenant's own UI and workbooks show. The row list
// itself — engine wiring, the letters band, the served icon box, the suggestion rule, and the
// coded refusal messages — lives in OverlayRows.tsx (extracted part 4b); this file is the thin
// card shell over it. (Part 4b briefly generalised OverlayRows over a second, families-shaped
// list for a now-deleted "Oberfläche" card — operator ruling R36.6, 2026-09-28 — so OverlayRows
// is axes-only again and takes no `section` prop.)</purpose>
// <dependencies>OverlayRows (the row list); BentoCard.tsx.</dependencies>
// <constraints>The rail can NEVER add or remove a value — see OverlayRows.tsx's own
// constraints.</constraints>

// Re-exported for callers/tests written against this module's original export surface.
export { rowKeyFor };

const VokabularVerwaltung: React.FC = () => (
  <BentoCard title="Vokabular">
    <OverlayRows
      loadErrorContext="Laden des Vokabulars"
      intro="Bezeichnungen und Kürzel der Klassifizierungswerte, wie sie in dieser Oberfläche und in Ihren Auswertungen erscheinen. Änderungen wirken sofort — ohne Deployment. Die Werte selbst bleiben unverändert."
    />
  </BentoCard>
);

export default VokabularVerwaltung;
